/**
 * Generate an RFC 4122 version 4 UUID.
 * Uses `crypto.randomUUID` in secure contexts; falls back to `getRandomValues` elsewhere
 * (e.g. local dev over HTTP on a custom host like localhost.detechtion.com).
 *
 * @returns {string}
 */
export function randomUUID() {
  if (typeof crypto?.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");

  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
